export enum DuluxLocationPagesWorkspaceCapabilityAccessOperation {
    create = "3faf5c92-638b-43db-804c-59def850cd30",
    read = "d78cad36-8be4-4c68-8784-c2f0ca4e856c",
    update = "ed996087-0fec-439e-a00d-6b364cdb18a5",
    delete = "7294e09f-a3a4-4abc-8d46-e41e1519920e",
}
